export default {
  DEFINITIONS_SET: 'DEFINITIONS_SET',
};
